
import { defineComponent, onBeforeMount, reactive } from 'vue'

import type { PropType } from 'vue'
import type { PreTripDetailsRescheduleHistoryItem, PreTripUpdateCommentPayload } from '@/core/types/tms-graph.types'

import NewModal from '@/common/new-components/NewModal/index.vue'
import NewInput from '@/ui-kit/NewInput/index.vue'

import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import { tmsGraph } from '@/core/realisations/tms-graph.realisation'

import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        NewModal,
        NewInput,
    },
    props: {
        item: {
            type: Object as PropType<PreTripDetailsRescheduleHistoryItem>,
            default: null
        }
    },
    emits: ['close', 'success'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            comment: null as string | null
        })

        const state_form$ = useVuelidate(
            {
                comment: { required },
            },
            state
        )

        const onSubmit = async () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            try {
                state.is_loading = true

                const payload: PreTripUpdateCommentPayload = {
                    comment: state.comment as string
                }

                // @ts-ignore
                await tmsGraph.updateComment(props.item.preTripCommentId, payload)

                notifications.notify({ title: 'Комментарий сохранен', type: 'success' })
                onSuccess()
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При редактировании комментария произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        const onSuccess = () => {
            emit('success')
        }

        const onClose = () => {
            emit('close')
        }

        onBeforeMount(() => {
            if (props.item) {
                state.comment = props.item.commentInfo
            }
        })

        return {
            state,
            state_form$,
            onSubmit,
            onClose,
        }
    },
})
